import { render, staticRenderFns } from "./PageEmptyComponent.vue?vue&type=template&id=fe81378e&"
import script from "./PageEmptyComponent.vue?vue&type=script&lang=js&"
export * from "./PageEmptyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports